var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10C12.042969 10 8 14.042969 8 19L8 32L10 32L10 19C10 15.121094 13.121094 12 17 12C20.878906 12 24 15.121094 24 19L24 34L9.0625 34C9.042969 34 9.019531 34 9 34L3 34C2.96875 34 2.9375 34 2.90625 34C2.355469 34.027344 1.925781 34.496094 1.953125 35.046875C1.980469 35.597656 2.449219 36.027344 3 36L9 36C9.03125 36 9.0625 36 9.09375 36L28 36L28 46L30 46L30 36L32 36L32 46L34 46L34 36L47 36C47.550781 36 48 35.550781 48 35L48 19C48 14.042969 43.957031 10 39 10 Z M 22.625 12L39 12C42.878906 12 46 15.121094 46 19L46 34L26 34L26 19C26 16.171875 24.675781 13.652344 22.625 12 Z M 32 17C30.894531 17 30 17.894531 30 19C30 20.105469 30.894531 21 32 21C32.738281 21 33.371094 20.597656 33.71875 20L39 20L39 24L43 24L43 18L33.71875 18C33.371094 17.402344 32.738281 17 32 17Z",
    fill: "rgb(153, 0, 204)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostBox);
export default __webpack_public_path__ + "static/media/post_box.e850c2cd58fab78a690e282c2330f78e.svg";
export { ForwardRef as ReactComponent };